(function () {
  'use strict';
  // Marcar que JS esta presente: la decoracion entra en escena solo si hay JS.
  document.documentElement.classList.add('olaryz-js');

  // Adorno por familia: entrada suave cuando el SVG es visible.
  // Los SVG viven en el DOM desde el principio (olaryz-atmosphere en olaryz-head).
  function prepararAdornos() {
    var adornos = document.querySelectorAll('[data-olaryz-family] .olaryz-spider, [data-olaryz-family] .olaryz-star');
    if (!adornos.length) { return; }
    function marcar(el) {
      el.classList.add(el.classList.contains('olaryz-star') ? 'olaryz-star--in-view' : 'olaryz-spider--in-view');
    }
    if (!('IntersectionObserver' in window)) {
      adornos.forEach(marcar);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { marcar(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    adornos.forEach(function (a) { io.observe(a); });
  }

  // Comparison slider nativo: el tema enlaza input<->--compare para el bloque; aqui
  // se garantiza la misma sincronizacion para el componente instanciado desde
  // olaryz-proof (compatible con el runtime del tema: operacion idempotente).
  function syncSlider(input) {
    var media = input.closest('.comparison-slider__media-wrapper');
    if (media && input.value) {
      media.style.setProperty('--compare', input.value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepararAdornos);
  } else {
    prepararAdornos();
  }
  // Delegacion: cubre raton/teclado y cargas posteriores (editor, reinicios).
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input.cs-slider')) { syncSlider(t); }
  });
})();